/* eslint-disable */
import { CHECKER_NORMAL_24 } from "@sznds/icons/index";
import createSDSIcon from "~/ui/icon";
import { node } from "~/util/dom";
import { fetchActiveRequests, fetchActiveRequest, setNotificationState, updateReviewState } from "~/util/providers/review";
import ActiveRequestCloseDialog from "./closedialog";
import { IEvent, IEventsListResponse } from "./interfaces";
import RequestDialog from "./requestdialog";
import { store } from "~/state/store";
import { getFirmLogObj, getSignal, getTypePoi } from "./util";
import { _ } from "~/i18n";

/**
 * Jediná chytrá věc v rámci aktivních žádostí z notifikace, zbytek jsou hloupé dialogy, co na všechno dostanou callback právě od tohohle správce.
 */
export default class ActiveRequest {
	_active: boolean;
	_events: Array<IEvent>;
	_requestDialog: RequestDialog;

	constructor() {
		this._active = false;
		this._events = [];

		window.addEventListener("click", this, true);
	}

	destroy() {
		window.removeEventListener("click", this, true);
		this._requestDialog?.destroy();
	}

	handleEvent(event: MouseEvent) {
		// kliklo se na mapovy odkaz v notifikacich?
		const link = (event.target as HTMLElement)?.closest?.(`div#notification-list ul li[data-dot="item-promo.mapy"] a`) as HTMLAnchorElement;
		const closeBtn = (event.target as HTMLElement)?.closest?.(`div#notification-list ul li[data-dot="item-promo.mapy"] button[data-dot="close"]`) as HTMLAnchorElement;

		if (link) {
			event.preventDefault();

			const url = new URL(link.href);
			const params = new URLSearchParams(url.searchParams);

			// jde o zadost o hodnoceni
			if (params.has("rrid")) {
				const eventId = parseInt(params.get("rrid"));

				this.startReviews(eventId, true).then(() => {
					const found = this._events.find(event => event.id === eventId);

					if (found) {
						// analytika
						this._sendAnalytics("click", {
							text: "notification",
							signal: getSignal(found),
							type: "suggestionReviews",
							state: "unread",
							section: "accounts",
						});
					}
				}, () => {});
				setNotificationState(eventId, "opened");
			} else if (params.has("drrid")) {
				const eventId = parseInt(params.get("drrid"));
				const source = params.get("source");
				const id = parseInt(params.get("id"));
				const dra = params.get("dra");

				this.loadEvents().then(() => {
					const found = this._events.find(event => event.id === eventId);

					if (found) {
						// analytika
						this._sendAnalytics("click", {
							text: "notification",
							signal: getSignal(found),
							type: "updateReviews",
							state: "unread",
							section: "accounts",
						});
					}
				}, () => {});

				Mapy.getComponent("detail").setState({
					source,
					id,
					dra,
					drrid: eventId,
				});
				setNotificationState(eventId, "opened");
			}
		} else if (closeBtn) {
			const itemEl = (event.target as HTMLElement)?.closest(`li[data-dot="item-promo.mapy"]`);

			if (itemEl) {
				const link = itemEl.querySelector("a").href;
				const match = link.match(/([d]*rrid)=(\d+)/);

				match && this.closeReview(parseInt(match[2]), match[1] === "drrid" ? "updateReviews" : "suggestionReviews");
			}
		}
	}

	activate() {
		if (this.isActive()) { return this; }

		this._active = true;

		return this;
	}

	deactivate() {
		if (!this.isActive()) { return this; }

		this._active = false;
		this._events = [];

		return this;
	}

	isActive() {
		return this._active;
	}

	setState(state) {
		// je tam neco pro nas
		if ("rrid" in state) {
			const { user } = store.getState().user;

			if (user.state === "green") {
				// muzeme pokracovat
				this.startReviews(parseInt(state.rrid));
			} else {
				// uzivatel se musi prihlasit, jinak nic nebude
				Mapy.getComponent("login").open({
					analyticsData: {
						loginOrigin: "reviewsAdd",
						section: "reviews",
					},
					motivation: "review",
				}).then(() => {
					this.startReviews(parseInt(state.rrid));
				}, e => {});
			}
		}
	}

	getState() {
		// pri interakci s mapou (tedy zavrel dialog), neni co poslat a dokud nezavrel, tak neni, co by s mapou mohl delat, takze nikdy nic do historie
		return {};
	}

	async loadEvents() {
		// nasosame data
		try {
			const response = await fetchActiveRequests();
			const result = await response.json() as IEventsListResponse;

			// pro budouci potreby si zapamatujeme vsechny navrhovane eventy
			this._events = result.events;
		} catch (ex) {
			console.log(ex);
		}
	}

	async startReviews(rrid: number, fromNotifications?: boolean) {
		try {
			await this.loadEvents();

			const index = this._events.findIndex(event => event.id === rrid);

			// pokud POI z URL neni v aktivnich zadostech, tak tise vyhnijeme, protoze proste nema hodnotit
			if (index === -1) {
				throw new Error(`${rrid} nema prihlaseny uzivatel v aktivnich zadostech.`);
			}

			const firstEvent = this._events.splice(index, 1)[0];
			// hodnotil jsem
			let ratedCount = 0;
			// na kterem jsem poii
			let loadedPois = 0;
			let isLastEventCorrected = false;

			// sestavime dialog s uvodnim UI
			this._requestDialog = new RequestDialog({
				activeRequest: fromNotifications || false,
				onClose: () => {
					const lastEvent = this._requestDialog.lastEvent;
					const typePoi = getTypePoi(isLastEventCorrected, loadedPois);
					const signal = getSignal(lastEvent);

					this._sendAnalytics("click", {
						text: "suggestionClose",
						signal,
						typePoi,
					});

					const closeDialog = new ActiveRequestCloseDialog({
						onUnknownPlace: () => {
							this._sendAnalytics("click", {
								text: "Místo neznám",
								signal,
								typePoi,
							});
							this._sendAnalytics("suggestion_flow_close", {
								count: ratedCount,
								signal,
								typePoi,
								origin: "unknownPlace",
							});
							updateReviewState(lastEvent.id, "wrong_poi");
							closeDialog.close();
							closeDialog.destroy();
						},
						onRemindLater: () => {
							this._sendAnalytics("click", {
								text: "Připomenout později",
								signal,
								typePoi,
							});
							this._sendAnalytics("suggestion_flow_close", {
								count: ratedCount,
								origin: "remindLater",
								signal,
								typePoi,
							});
							updateReviewState(lastEvent.id, "deferred");
							closeDialog.close();
							closeDialog.destroy();
						},
						onRemindNever: () => {
							this._sendAnalytics("click", {
								text: "Místo už nikdy nepřipomínat",
								signal,
								typePoi,
							});
							this._sendAnalytics("suggestion_flow_close", {
								count: ratedCount,
								origin: "remindNever",
								signal,
								typePoi,
							});
							updateReviewState(lastEvent.id, "never_this_poi");
							closeDialog.close();
							closeDialog.destroy();
						},
						onCancel: () => {
							this._sendAnalytics("click", {
								text: "backFromClose",
								signal,
								typePoi,
							});
							closeDialog.close();
							closeDialog.destroy();
							this._requestDialog.open();
						},
						onClose: () => {
							this._sendAnalytics("click", {
								text: "backFromClose",
								signal,
								typePoi,
							});
							closeDialog.close();
							closeDialog.destroy();
							this._requestDialog.open();
						},
					});

					this._requestDialog.close();
					closeDialog.open();
				},
				onNext: async () => {
					// analytika
					this._sendAnalytics("click", {
						text: "Další místo",
						signal: getSignal(this._requestDialog.lastEvent),
						typePoi: getTypePoi(isLastEventCorrected, loadedPois),
					});

					if (this._events.length) {
						const nextEvent = this._events.splice(0, 1)[0];

						loadedPois++;
						await this._requestDialog.request({
							event: nextEvent,
							next: !!this._events.length,
							animate: true,
						});
						isLastEventCorrected = false;
					}
				},
				onRated: async (event, myReview) => {
					// pokud fakt hodnotil, posleme na BE spravne zmeny stavu
					ratedCount++;

					if (myReview) {
						if (myReview.text) {
							updateReviewState(event.id, "rated_review");
						} else {
							updateReviewState(event.id, "rated");
						}
					}

					if (this._events.length) {
						const nextEvent = this._events.splice(0, 1)[0];
						const msg = node("div");
						const p = node("p", { innerHTML: _("activerequest.close.thanksRated") });

						msg.appendChild(createSDSIcon({
							symbol: CHECKER_NORMAL_24,
						}));
						msg.appendChild(p);
						this._requestDialog.open();
						this._requestDialog.onClose = () => {
							this._sendAnalytics("suggestion_flow_close", {
								count: ratedCount,
								origin: "line",
								signal: getSignal(this._requestDialog.lastEvent),
								typePoi: getTypePoi(isLastEventCorrected, loadedPois),
							});

							this._requestDialog.close();
						};
						await this._requestDialog.transitionToMessage(msg);
						loadedPois++;
						await this._requestDialog.request({
							event: nextEvent,
							next: !!this._events.length,
							animate: true,
						});
						isLastEventCorrected = false;
					} else {
						this._sendAnalytics("suggestion_flow_close", {
							count: ratedCount,
							origin: "emptyLine",
							signal: getSignal(this._requestDialog.lastEvent),
							typePoi: getTypePoi(isLastEventCorrected, loadedPois),
						});
					}
				},
				onReviewClick: type => {
					this._sendAnalytics("click", {
						text: type === "agr" ? "podmínkami" : "pravidly",
						signal: getSignal(this._requestDialog.lastEvent),
						typePoi: getTypePoi(isLastEventCorrected, loadedPois),
					});
				},
				onRemoved: () => {
					// analytika
					this._sendAnalytics("suggestion_flow_close", {
						count: ratedCount,
						signal: getSignal(this._requestDialog.lastEvent),
						origin: "deleteReview",
						typePoi: getTypePoi(isLastEventCorrected, loadedPois),
					});
				},
				onPoiChoiceOpen: () => {
					// analytika
					this._sendAnalytics("click", {
						text: "Byli jste jinde",
						signal: getSignal(this._requestDialog.lastEvent),
						typePoi: getTypePoi(isLastEventCorrected, loadedPois),
					});
				},
				onPoiChoiceSelect: () => {
					this._sendAnalytics("click", {
						text: "suggestionCorrect",
						signal: getSignal(this._requestDialog.lastEvent),
						typePoi: getTypePoi(isLastEventCorrected, loadedPois),
					});

					isLastEventCorrected = true;
				},
				onPoiChoiceClose: () => {
					this._sendAnalytics("click", {
						text: "backFromCorrection",
						signal: getSignal(this._requestDialog.lastEvent),
						typePoi: getTypePoi(isLastEventCorrected, loadedPois),
					});
				},
				onInvalidRequest: async () => {
					this._sendAnalytics("click", {
						text: "Není to žádné z těchto míst",
						typePoi: getTypePoi(isLastEventCorrected, loadedPois),
						signal: getSignal(this._requestDialog.lastEvent),
					});

					if (this._events.length) {
						const nextEvent = this._events.splice(0, 1)[0];
						const msg = node("div");
						const p = node("p", { innerHTML: _("activerequest.close.thanksInvalidRequest") });

						// TODO: spravna ikona - ted neni v systemu
						msg.appendChild(createSDSIcon({
							symbol: CHECKER_NORMAL_24,
						}));
						msg.appendChild(p);
						this._requestDialog.open();
						await this._requestDialog.transitionToMessage(msg);
						loadedPois++;
						await this._requestDialog.request({
							event: nextEvent,
							next: !!this._events.length,
							animate: true,
						});
						isLastEventCorrected = false;
					} else {
						this._sendAnalytics("suggestion_flow_close", {
							count: ratedCount,
							origin: "emptyLine",
							signal: getSignal(this._requestDialog.lastEvent),
							typePoi: getTypePoi(isLastEventCorrected, loadedPois),
						});
					}
				},
				getFirmLog: (event: IEvent) => {
					return getFirmLogObj(event, isLastEventCorrected, loadedPois);
				},
			});

			const { user } = store.getState().user;
			loadedPois++;
			await this._requestDialog.request({
				event: firstEvent,
				user: user.name,
			});
			this._requestDialog.open();
		} catch (ex) {
			console.log(ex);
		}
	}

	async closeReview(rrid: number, type: string) {
		try {
			const response = await fetchActiveRequest(rrid);
			const event = await response.json() as IEvent;
			const signal = getSignal(event);

			this._sendAnalytics("click", {
				text: "closeNotification",
				type,
				state: "unread",
				section: "accounts",
				signal,
			});
			this._sendAnalytics("suggestion_flow_close", {
				count: 0,
				origin: "closeNotificationUnread",
				typePoi: "suggested",
				section: "suggestionNotification",
				signal,
			});
		} catch (ex) {
			console.log(ex);
		}
	}

	_sendAnalytics(action, opts) {
		Mapy.getComponent("logger").log(action, {
			section: "suggestionNotification",
			...opts,
		});
	}
}
